import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { KENDO_TREEVIEW } from '@progress/kendo-angular-treeview';
import { Observable, of } from 'rxjs';
import { ModalOptions } from '../../../widgets/models';
import { CommonService } from '../../../widgets/services/common.service';


@Component({
  selector: 'app-pinned-push-to-teams',
  standalone: true,
  imports: [DropDownsModule, FormsModule, KENDO_TREEVIEW],
  templateUrl: './pinned-push-to-teams.component.html',
  styleUrls: ['./pinned-push-to-teams.component.scss']
})
export class PinnedPushToTeamsComponent {
  @Input() options: ModalOptions = new ModalOptions();
  params: any[] = [];
  pushTitle: string = "";
  treeviewBindData: any;
  selectedSubFolder: string = "";
  currentSelectedDropdown: string="";
  @Input() teamFolderIdDetail!: string;
  @Output() closePopup= new EventEmitter<boolean>();
    selectedTeamId:any = null;
    selectedFolderId: any = null;
  selectedFolderName: any = null;
  spinnerVisible: boolean = false;
  treeviewData!: any[];
  treeviewReturnData: any;
 
  fetchData(ev: any) {
  }
  constructor(private commonService: CommonService, private http: HttpClient, public activeModal: NgbActiveModal) {
    localStorage.setItem("lastId", "");
    if (this.params[0])
    {
      this.teamFolderIdDetail = this.params[0].teamFolderIdDetail;
    }
    this.LoadTeams();
    
  }
  


  teamsData!: Teams[];
  public dropdownData!: Array<{ id: string, teamName: string, webUrl: string }>;
  public valueChange(value: any): void {
  }
  ngAfterViewInit() {
    setInterval(() => {
      (document.getElementsByClassName("fa-spin-details")[0] as HTMLElement).style.display = "none";
    }, 1000);
  }


  p() {
    if (localStorage.getItem("lastId") != "" && this.selectedSubFolder != "") {
      var currentSelectedDropdown = localStorage.getItem("lastId");
      this.commonService.getremotefoldersforteam(this.selectedSubFolder, currentSelectedDropdown?.toString()).then((data) => {
        this.treeviewBindData = data;
      })
    }
  }
  LoadTeams() {
    //(document.getElementsByClassName("fa-spin-details")[0] as HTMLElement).style.display = "block";
    this.pushTitle = "";
    this.commonService.loadTeams().then((teams) => {
      if (teams.length == 1) {
        (document.getElementById("noTeamDD") as HTMLElement).style.display = "block";
        (document.getElementById("teamDD") as HTMLElement).style.display = "none";
        (document.getElementsByClassName("fa-spin-details")[0] as HTMLElement).style.display = "none";
      } else {
        this.teamsData = teams;
        this.dropdownData = this.teamsData;

      }

    });
  }
  onSelectMSTeam(e: Teams) {
    this.pushTitle = "";
    this.treeviewData = [];
    (document.getElementsByClassName("fa-spin-details")[0] as HTMLElement).style.display = "block";

  // Disable the upload as user needs to select a folder first
    (document.getElementById('uploadButton') as HTMLElement).setAttribute('disabled', 'disabled');
    (document.getElementById('uploadButton') as HTMLElement).style.opacity = '0.5';
    if (this.selectedTeamId) {
      this.commonService.getTeamFolders(e.id).then((data) => {
        this.currentSelectedDropdown = data;
        this.treeviewData = data;
        localStorage.setItem("lastId", data);
        this.commonService.getremotefoldersforteam("00000000-0000-0000-0000-000000000000", data).then((data) => {
          this.treeviewData = data;
          this.pushTitle = "Select folder to push files to";
          (document.getElementsByClassName("fa-spin-details")[0] as HTMLElement).style.display = "none";
        })
      });
  }

  } 
  public fetchChildren(node: any): Observable<any[]>{
    return of(node.items);
  }
  public hasChildren(node: any): boolean {
    if (node.hasChildren == true)
      return true;
    else
      return false;
  }
  uploadFiles() {
  (document.getElementById('uploadButton') as HTMLElement).setAttribute('disabled', 'disabled');
  (document.getElementById('uploadButton') as HTMLElement).style.opacity = '0.5';
  var encodedPackageKey = encodeURIComponent('@Model.PackageName').replace(/%/g, "!");

    this.commonService.uploadsharepointfiles(encodedPackageKey, this.selectedTeamId, this.selectedFolderId).then((data) => {
    })
  
}
  closePopupDiv(event: any) {
    //(document.getElementsByClassName("fa-spin-details")[0] as HTMLElement).style.display = "none";
    //this.closePopup.emit(event);
   // this.options.
    this.activeModal.close('success');
  }
}
export interface Teams {
  id: string;
  teamName: string;
  webUrl: string;
}


